import { Routes } from '@angular/router';
import { AppInitializedGuard } from '@examdojo/app-state';
import { NotFoundComponent } from './not-found.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AppInitializedGuard],
    component: NotFoundComponent,
    title: 'Not found',
  },
];
